/** Pipeline stage / Add Lead "Label" values — must not be shown as Source. */
const PIPELINE_LABEL_RE =
  /opportunity|assessment|assesment|need\s*analysis|proposal|quotation|negotiation|review|closed\s*(won|lost)|^\s*lost\s*$|^\s*won\s*$|^\s*lead\s*$/i;

const KNOWN_SOURCES = new Set([
  'website',
  'facebook',
  'google',
  'tiktok',
  'instagram',
  'x',
  'linkedin',
  'others',
  'referral',
  'cold call',
  'cold',
]);

/**
 * bookingFrequency is packed as `Source|PipelineLabel` when saved from Add Lead.
 * Older rows may store only a stage name or only a source.
 */
export function parseLeadBookingFrequency(bookingFrequency) {
  const raw = String(bookingFrequency || '').trim();
  if (!raw) {
    return { source: 'Website', label: null };
  }

  if (raw.includes('|')) {
    const [sourcePart, ...rest] = raw.split('|');
    const source = sourcePart.trim();
    const label = rest.join('|').trim() || null;
    if (source && !PIPELINE_LABEL_RE.test(source)) {
      return { source, label };
    }
    return { source: source || 'Website', label };
  }

  if (PIPELINE_LABEL_RE.test(raw) && !KNOWN_SOURCES.has(raw.toLowerCase())) {
    return { source: 'Website', label: raw };
  }

  return { source: raw, label: null };
}

export function packLeadBookingFrequency(source, label) {
  const src = String(source || 'Website').trim() || 'Website';
  const lbl = String(label || '').trim();
  return lbl ? `${src}|${lbl}` : src;
}

export function parseLeadSource(bookingFrequency) {
  return parseLeadBookingFrequency(bookingFrequency).source;
}

export function parseLeadPipelineLabel(bookingFrequency) {
  return parseLeadBookingFrequency(bookingFrequency).label;
}
